import { Route, Routes } from "react-router-dom";
import { DiagnosticsLayout } from "~/DiagnosticsApp/components";
import { ConfirmationPage } from "~/DiagnosticsApp/pages/ConfirmationPage";
import DashboardPage from "~/DiagnosticsApp/pages/DashboardPage/DashboardPage";
import IntakeCompletePage from "~/DiagnosticsApp/pages/IntakeCompletePage";
import IntakePage from "~/DiagnosticsApp/pages/IntakePage";
import PatientFormPage from "~/DiagnosticsApp/pages/PatientFormPage";
import { Protector } from "./Protector";

export const DiagnosticsRoutes = () => {
  return (
    <Routes>
      <Route element={<DiagnosticsLayout />}>
        <Route
          path="/patient-form/:slug"
          element={
            <Protector protectDiagnostics>
              <PatientFormPage />
            </Protector>
          }
        />
        <Route
          path="/confirmation"
          element={
            <Protector requireDiagnostics>
              <ConfirmationPage />
            </Protector>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Protector requireDiagnostics>
              <DashboardPage />
            </Protector>
          }
        />
        <Route
          path="/products/:diagnostic_user_product_id/intake"
          element={
            <Protector requireDiagnostics>
              <IntakePage />
            </Protector>
          }
        />
        <Route
          path="/consultations/intake_completed"
          element={
            <Protector requireDiagnostics>
              <IntakeCompletePage />
            </Protector>
          }
        />
      </Route>
    </Routes>
  );
};
